// Die Karte der App - unveraendert, mit oder ohne Schluessel. Server
// (server/src/map.js) und Web-App (web/src/lib/map.ts) teilen sich die
// Standard-Kachelquelle, damit sie nie auseinanderlaufen.
export const CARTO_TILES = {
  tileUrl: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
  attribution: '&copy; OpenStreetMap, &copy; CARTO',
  subdomains: 'abcd',
  maxZoom: 20,
};
